import axios from "axios";
import { ADJUSTMENT_INVENTORY_URL } from "../actions/url";
import { DEFAULT_ERROR } from '../components/Common/constants';

import {
    REQUEST_REASONS,
    REQUEST_REASONS_SUCCESS,
    REQUEST_REASONS_FAILURE,
    START_REASON_CREATION,
    REASON_CREATION_SUCCESS,
    REASON_CREATION_FAILURE,
    START_REASON_EDITING,
    REASON_EDITING_SUCCESS,
    REASON_EDITING_FAILURE,
    REQUEST_DELETE_REASON,
    REASON_DELETE_SUCCESS,
    REASON_DELETE_FAILURE,
    SELECT_REASON,
    RESET_CURRENT_REASON,
    REQUEST_ADJUSTMENT_LOGS,
    ADJUSTMENT_LOG_SUCCESS,
    ADJUSTMENT_LOG_FAILURE,
} from "./type";

import { ROOT_URL, isGGI } from "./root_url";

export function fetchReasons() {
    return dispatch => {
        dispatch({type: REQUEST_REASONS});
        return axios.get(ADJUSTMENT_INVENTORY_URL,
            {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
            },
        )
        .then(response => {
            dispatch(fetchReasonsSuccess(response))
        }, (err) => {
            if (err.status === 500 || err.status === 404) {
                err.status = DEFAULT_ERROR;
            }
            if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
            } else {
                dispatch(fetchReasonsFailure(err));
            }
        })
    }
}

export function fetchReasonsSuccess(data) {
    return {
    type: REQUEST_REASONS_SUCCESS,
    payload: data
    }
}

export function fetchReasonsFailure(err) {
    return {
    type: REQUEST_REASONS_FAILURE,
    payload: err
    }
}

export function createReason({ReasonDesc}) {
    return dispatch => {
        dispatch({type: START_REASON_CREATION})
        return axios.post(`${ADJUSTMENT_INVENTORY_URL}/`,
            [
                {
                    ReasonDesc
                }
            ],
            {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
            },
        )
        .then(response => {
            dispatch(createReasonSuccess(response));
        }, (err) => {
            if (err.status === 500 || err.status === 404) {
                err.status = DEFAULT_ERROR
            }
            if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
            } else {
                dispatch(createReasonFailure(err));
            }
        })
    }
}

export function createReasonSuccess(data) {
    return {
        type: REASON_CREATION_SUCCESS,
        payload: data
    }
}

export function createReasonFailure(err) {
    return {
        type: REASON_CREATION_FAILURE,
        payload: err 
    }
}

export function editReason({ReasonDesc}, id) {
    return dispatch => {
        dispatch({type: START_REASON_EDITING})
        return axios.post(`${ADJUSTMENT_INVENTORY_URL}/`,
            [
                {
                id,
                ReasonDesc
                }
            ],
            {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
            }, 
        )
        .then(response => {
            dispatch(editReasonSuccess(response))
        }, (err) => {
            if (err.status === 500 || err.status === 404) {
                err.status = DEFAULT_ERROR
            }
            if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
            } else {
                dispatch(editReasonsFailure(err))
            }
        })
    }
}


export function editReasonSuccess(data) {
    return {
        type: REASON_EDITING_SUCCESS,
        payload: data
    }
}

export function editReasonsFailure(err) {
    return {
        type: REASON_EDITING_FAILURE,
        payload: err
    }
}

export function deleteReason(id) {
    return dispatch => {
        dispatch({type: REQUEST_DELETE_REASON})
        return axios.delete(`${ADJUSTMENT_INVENTORY_URL}/${id}`,
            {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
            }
        )
        .then(response => {
            dispatch(deleteReasonSuccess(response));
        }, (err) => {
            if (err.status === 500 || err.status == 404) {
                err.status = DEFAULT_ERROR
            }
            if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
            } else {
                dispatch(deleteReasonFailure(err));
            }
        })
    }
}

export function deleteReasonSuccess(data) {
    return {
        type: REASON_DELETE_SUCCESS,
        payload: data
    }
}

export function deleteReasonFailure(err) {
    return {
        type: REASON_DELETE_FAILURE,
        payload: err
    }
}

export function selectReason(data) {
    return {
        type: SELECT_REASON,
        payload: data
    };
}

export function resetCurrentReason() {
    return {
        type: RESET_CURRENT_REASON
    }
}

export function grabAdjustmentLogs(limit) {
    if (!limit) {
        limit = 100;
    }

    let page = 1;
    return (dispatch) => {
        dispatch({type: REQUEST_ADJUSTMENT_LOGS})
        return axios.get(`${ROOT_URL}v1/adjustment-inventory/?limit=${limit}&page=${page}`,
        {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        }
        )
        .then((response) => {
            dispatch(grabAdjustmentLogsSuccess(response));
        }, (err) => {
            if (err.status === 500 || err.status === 404) {
                err.status = DEFAULT_ERROR;
            }
            if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
            } else {
                dispatch(grabAdjustmentLogsFailure(err));
            }
        })
    }
}

export function grabAdjustmentLogsSuccess(data) {
    return {
        type: ADJUSTMENT_LOG_SUCCESS,
        payload: data
    }
}


export function grabAdjustmentLogsFailure(err) {
    return {
        type: ADJUSTMENT_LOG_FAILURE,
        payload: err
    }
}


// WEBPACK FOOTER //
// ./master/jsx/actions/adjustmentInventory_actions.js